import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yy-location",
  "use": "icon-yy-location-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-yy-location\">\r\n<path d=\"M100,0C60.4,0,28.3,29.9,28.3,66.7c0,32.2,27.4,71.8,58.2,126c4.2,6.9,13.6,9.4,21,5.5c2.5-1.3,4.5-3.2,5.9-5.5\r\n\tc30.8-54.2,58.2-93.8,58.2-126C171.7,29.9,139.6,0,100,0z M100,100c-19.8,0-35.8-14.9-35.8-33.3s16-33.3,35.8-33.3\r\n\ts35.8,14.9,35.8,33.3S119.8,100,100,100z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yy-location.svg
// module id = QKCR
// module chunks = 13